import { Col, Layout, Row, Spin, Alert } from "antd";
import { useEffect, useState } from "react";
import { useMediaPredicate } from "react-media-hook";
import { Link } from "react-router-dom";
import { DownloadOutlined } from "@ant-design/icons";
import Button from "../../components/Button";
import Burger from "../../components/layouts/HomeLayout/Burger";
import Footer from "../../components/layouts/HomeLayout/Footer";
import { useScroll } from "../../utils/useScroll";
import UsadosBanner from "../../assets/img/Gamausados.webp";
import Logo from "../../assets/img/logo-mobility.webp";
import { useDispatch, useSelector } from "react-redux";
import { getPostsHeaderContent } from "../../store/strapi/gamaleasing";
import { getGamaLeasingPostsContent } from "../../store/strapi/gamaleasing/thunks";

const STRAPI_URL =
  process.env.REACT_APP_STRAPI_API_URL || "http://localhost:1337";

function Posts() {
  const biggerThan900 = useMediaPredicate("(min-width: 992px)");
  const [visible, setVisible] = useState(false);
  const [documentos, setDocumentos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getGamaLeasingPostsContent());
    fetchDocumentosFinancieros();
  }, []);

  const fetchDocumentosFinancieros = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${STRAPI_URL}/documentos-financieros?populate=*&pagination[start]=0&pagination[limit]=100`,
      );

      if (!response.ok) {
        throw new Error("Error al cargar los documentos");
      }

      const data = await response.json();

      const documentosOrdenados = (data.data || []).sort((a, b) => {
        const fechaA = new Date(a.Fecha);
        const fechaB = new Date(b.Fecha);
        return fechaB - fechaA;
      });

      setDocumentos(documentosOrdenados);
      setError(null);
    } catch (err) {
      console.error("Error fetching documentos:", err);
      setError("No se pudieron cargar los documentos financieros");
    } finally {
      setLoading(false);
    }
  };

  const agruparDocumentos = (docs) => {
    return docs.reduce((acc, doc) => {
      const tipo = doc.Tipo;
      if (!acc[tipo]) {
        acc[tipo] = [];
      }
      acc[tipo].push(doc);
      return acc;
    }, {});
  };

  const getDownloadUrl = (record) => {
    const documentos = record.Documento;

    if (!documentos || !Array.isArray(documentos) || documentos.length === 0) {
      return null;
    }

    const archivo = documentos[0];

    if (archivo && archivo.url) {
      return archivo.url;
    }

    return null;
  };

  const handleDownload = async (doc) => {
    const url = getDownloadUrl(doc);
    const fileName =
      doc.Documento && doc.Documento.length > 0
        ? doc.Documento[0].name
        : `${doc.Titulo}.pdf`;

    if (!url) return;

    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Error downloading file:", error);
      window.open(url, "_blank");
    }
  };

  const postsHeader = useSelector(getPostsHeaderContent);
  const { scrollDirection } = useScroll();
  const [isHome, setIsHome] = useState();

  const burguerData = [
    {
      title: "Sucursales",
      link: "/sucursales",
    },
    {
      title: "Nuestros servicios",
      link: "/mobility#servicios",
    },
    {
      title: "Quienes Somos",
      link: "/mobility#nosotros",
    },
    { title: "Beneficios", link: "/mobility#beneficios" },
    { title: "Publicaciones", link: "/mobility#publicaciones" },
  ];

  useEffect(() => {
    if (window.location.pathname === "/posts") {
      setIsHome(false);
    } else {
      setIsHome(true);
    }
  }, [window.location.pathname]);

  const styles = {
    active: {
      transition: "all 0.2s ease-in-out",
    },
    hidden: {
      transition: "all 0.2s ease-in-out",
      transform: biggerThan900 && "translateY(-2.3rem)",
    },
  };

  const documentosAgrupados = agruparDocumentos(documentos);

  return (
    <div>
      <Layout>
        <section
          className="home-banner-container"
          id="header"
          style={{
            height: `80vh`,
          }}
        >
          <Row
            className="header-contain"
            style={{
              backgroundImage: `url(${
                postsHeader?.length === 0 || postsHeader === null
                  ? UsadosBanner
                  : postsHeader?.bannerImage?.[0]?.url
              })`,
            }}
          >
            <Col
              id="navbar"
              style={
                scrollDirection === "down" || !scrollDirection
                  ? styles.active
                  : styles.hidden
              }
            >
              <nav className="home-nav-container">
                <ul>
                  <li>
                    <a
                      target="_blank"
                      href={"https://gamamobility.cl/"}
                      rel="noreferrer"
                    >
                      GAMA MOBILITY
                    </a>
                  </li>
                  <li>
                    <Link
                      style={{
                        color:
                          window.location.pathname === "" ? "#FF3200" : "white",
                      }}
                      to={"/"}
                    >
                      GAMA LEASING
                    </Link>
                  </li>
                  <li>
                    <a href={"https://www.gamarent.cl/"}>RENT A CAR</a>
                  </li>
                  <li>
                    <a href={"https://www.tripp.cl/"}>TRIPP</a>
                  </li>
                  <li>
                    <Link to={"/usados"}>GAMA USADOS</Link>
                  </li>
                </ul>
              </nav>
              <header>
                <div className="home-nav-items">
                  <div className="home-nav-logo">
                    <Link to={"/mobility"}>
                      <img src={Logo} style={{ width: "130px" }} alt="Logo" />
                    </Link>
                  </div>
                  <div className="group-nav-items">
                    <div
                      className="nav-container-buttons"
                      style={{
                        transition: "all ease-out 1s;",
                        opacity: `${visible ? "0" : "1"}`,
                        pointerEvents: `${visible ? "none" : "auto"}`,
                      }}
                    >
                      <Link to="/contacto">
                        <Button
                          onClick={() => {}}
                          className="gama-outline talk-button"
                        >
                          Conversemos
                        </Button>
                      </Link>
                    </div>
                    <div className="container-menu">
                      {biggerThan900 ? (
                        <div className="container-navlinks">
                          {isHome ? (
                            <>
                              <a smooth href="/sucursales">
                                Sucursales
                              </a>
                              <a smooth href="#servicios">
                                Nuestros Servicios
                              </a>
                              <a smooth href="#nosotros">
                                Quienes Somos
                              </a>
                              <a smooth href="#beneficios">
                                Beneficios
                              </a>
                              <a smooth href="#publicaciones">
                                Publicaciones
                              </a>
                            </>
                          ) : (
                            <>
                              <Link to="/sucursales">Sucursales</Link>
                              <Link to="/mobility#servicios">
                                Nuestros Servicios
                              </Link>
                              <Link to="/mobility#nosotros">Quienes Somos</Link>
                              <Link to="/mobility#beneficios">Beneficios</Link>
                              <Link to="/mobility#publicaciones">
                                Publicaciones
                              </Link>
                            </>
                          )}
                        </div>
                      ) : (
                        <Burger
                          data={burguerData}
                          boton={false}
                          modal={visible}
                          onClose={() => {
                            setVisible(!visible);
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </header>
            </Col>
          </Row>
          <div className="banner-title-container">
            <h1
              style={{
                textAlign: "0",
                paddingLeft: "0",
                color: "#FF3200",
              }}
            >
              {postsHeader?.length === 0 || postsHeader === null
                ? "Publicaciones"
                : postsHeader?.title?.Title}
            </h1>
            <h3
              style={{
                textAlign: "",
                lineHeight: "42px",
                fontSize: "40px",
                fontWeight: "400",
                width: biggerThan900 ? "1200px" : "100%",
                paddingLeft: "0",
              }}
            >
              {postsHeader?.length === 0 || postsHeader === null
                ? "En Gama nos preocupamos de mantener informados a nuestros clientes. Ingresa e infórmate con nuestras publicaciones periódicas."
                : postsHeader?.title?.Detail}
            </h3>
          </div>
        </section>
      </Layout>

      <div
        style={{
          padding: biggerThan900 ? "50px 100px" : "30px 20px",
          fontFamily: "Raleway, sans-serif",
          backgroundColor: "#f8f9fa",
        }}
      >
        {loading ? (
          <div style={{ textAlign: "center", padding: "50px" }}>
            <Spin size="large" />
            <p style={{ marginTop: "20px", fontFamily: "Raleway, sans-serif" }}>
              Cargando documentos...
            </p>
          </div>
        ) : error ? (
          <Alert
            message="Error"
            description={error}
            type="error"
            style={{ marginBottom: "30px" }}
          />
        ) : (
          <>
            {documentosAgrupados["Estados Financieros"] && (
              <div style={{ marginBottom: "60px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "30px",
                    padding: "20px",
                    backgroundColor: "white",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }}
                >
                  <div
                    style={{
                      width: "60px",
                      height: "60px",
                      backgroundColor: "#fff3e0",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "20px",
                    }}
                  >
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      fill="#ff9800"
                    >
                      <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                    </svg>
                  </div>
                  <div>
                    <h2
                      style={{
                        margin: 0,
                        fontSize: "28px",
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontFamily: "Raleway, sans-serif",
                      }}
                    >
                      Estados Financieros
                    </h2>
                  </div>
                </div>

                <div
                  style={{
                    backgroundColor: "white",
                    borderRadius: "8px",
                    padding: "20px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }}
                >
                  {documentosAgrupados["Estados Financieros"].map(
                    (doc, index) => (
                      <div
                        key={doc.id}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "12px 0",
                          borderBottom:
                            index <
                            documentosAgrupados["Estados Financieros"].length -
                              1
                              ? "1px solid #f0f0f0"
                              : "none",
                        }}
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="#95a5a6"
                          style={{ marginRight: "12px" }}
                        >
                          <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                        </svg>
                        <span
                          style={{
                            fontFamily: "Raleway, sans-serif",
                            fontSize: "16px",
                            color: "#2c3e50",
                            flex: 1,
                          }}
                        >
                          {doc.Titulo}
                        </span>
                        <button
                          onClick={() => handleDownload(doc)}
                          style={{
                            color: "#3498db",
                            background: "none",
                            border: "none",
                            textDecoration: "none",
                            fontFamily: "Raleway, sans-serif",
                            fontSize: "14px",
                            marginLeft: "10px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          <DownloadOutlined />
                          Descargar
                        </button>
                      </div>
                    ),
                  )}
                </div>
              </div>
            )}

            {documentosAgrupados["Memorias"] && (
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "30px",
                    padding: "20px",
                    backgroundColor: "white",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }}
                >
                  <div
                    style={{
                      width: "60px",
                      height: "60px",
                      backgroundColor: "#fff3e0",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "20px",
                    }}
                  >
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      fill="#ff9800"
                    >
                      <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                    </svg>
                  </div>
                  <div>
                    <h2
                      style={{
                        margin: 0,
                        fontSize: "28px",
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontFamily: "Raleway, sans-serif",
                      }}
                    >
                      Memorias
                    </h2>
                  </div>
                </div>

                <div
                  style={{
                    backgroundColor: "white",
                    borderRadius: "8px",
                    padding: "20px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }}
                >
                  {documentosAgrupados["Memorias"].map((doc, index) => (
                    <div
                      key={doc.id}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "12px 0",
                        borderBottom:
                          index < documentosAgrupados["Memorias"].length - 1
                            ? "1px solid #f0f0f0"
                            : "none",
                      }}
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="#95a5a6"
                        style={{ marginRight: "12px" }}
                      >
                        <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                      </svg>
                      <span
                        style={{
                          fontFamily: "Raleway, sans-serif",
                          fontSize: "16px",
                          color: "#2c3e50",
                          flex: 1,
                        }}
                      >
                        {doc.Titulo}
                      </span>
                      <button
                        onClick={() => handleDownload(doc)}
                        style={{
                          color: "#3498db",
                          background: "none",
                          border: "none",
                          textDecoration: "none",
                          fontFamily: "Raleway, sans-serif",
                          fontSize: "14px",
                          marginLeft: "10px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <DownloadOutlined />
                        Descargar
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {documentos.length === 0 && !loading && (
              <div style={{ textAlign: "center", padding: "50px" }}>
                <p
                  style={{
                    fontSize: "18px",
                    color: "#666",
                    fontFamily: "Raleway, sans-serif",
                  }}
                >
                  No hay documentos financieros disponibles en este momento.
                </p>
              </div>
            )}
          </>
        )}
      </div>

      <Footer logo={Logo} />
    </div>
  );
}

export default Posts;
